import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrapper overlay-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "overlay dark"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Loading...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "content-wrapper card card-body mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_dialog = _resolveComponent("app-dialog")!
  const _component_ap_dialog = _resolveComponent("ap-dialog")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_menu_sidebar = _resolveComponent("app-menu-sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_app_dialog),
    _createVNode(_component_ap_dialog),
    _createVNode(_component_app_header),
    _createVNode(_component_app_menu_sidebar),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_app_footer),
    (_ctx.screenSize === 'xs')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "sidebar-overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleMenuSidebar && _ctx.onToggleMenuSidebar(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}